import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const withoutKit = ['Errores en liquidaciones', 'Miedo a juicios laborales', 'Papeles desordenados', 'Resolver todo improvisando', 'Horas perdidas buscando info'];
  const withKit = ['Liquidaciones sin errores', 'Documentación que te protege', 'Legajos ordenados y digitales', 'Procesos paso a paso', 'Todo resuelto en minutos'];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-57">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-58">
        Sin Kit RRHH en orden vs Con Kit RRHH en orden
      </h2>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-59">
        <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6" data-id="element-60">
          <h3 className="text-xl font-bold text-red-700 mb-4 flex items-center gap-2" data-id="element-61">
            <XIcon className="w-6 h-6" data-id="element-62" />
            Sin Kit RRHH
          </h3>
          <ul className="space-y-3" data-id="element-63">
            {withoutKit.map((item, index) => <li key={index} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-64">
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-65" />
                <span data-id="element-66">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-emerald-50 border-2 border-emerald-200 rounded-lg p-6" data-id="element-67">
          <h3 className="text-xl font-bold text-emerald-700 mb-4 flex items-center gap-2" data-id="element-68">
            <CheckIcon className="w-6 h-6" data-id="element-69" />
            Con Kit RRHH
          </h3>
          <ul className="space-y-3" data-id="element-70">
            {withKit.map((item, index) => <li key={index} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-71">
                <CheckIcon className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-72" />
                <span data-id="element-73">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}